import styled from 'styled-components';
import { columnDirectionType } from './Header';

export const Main = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    column-gap: 8px;
    width: 100%;
    height: 94px;
    padding: 0 28px;
`;

export const MainText = styled.div`
    display: flex;
    align-items: center;
    column-gap: 8px;
    color: #5e00b5;
`;

export const MainTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 8px;
`;

export const ChildrenWrapper = styled.div<{ flexDirection?: columnDirectionType }>`
    display: flex;
    column-gap: 12px;
    row-gap: 12px;
    flex-direction: ${({ flexDirection = 'row' }) => flexDirection};
    align-items: end;
`;
